import useRootSelector from './useRootSelector';
import { selectCurrentUserSelectedLevel } from 'modules/authentication/state/selectors';
import { PermissionLevels } from 'common/constants/permissions';

export default function usePermissionLevel(): PermissionLevels | null {
  return useRootSelector(selectCurrentUserSelectedLevel) || null;
}
